/**
 * Single source of truth for every interaction-feedback event in the design
 * system. Components speak these semantic event names; the feedback layer maps
 * each one to a sound ({@link ./sounds}) and a haptic pattern ({@link ./haptics}).
 */
export type FeedbackEvent =
  | "tap"
  | "select"
  | "toggle-on"
  | "toggle-off"
  | "open"
  | "close"
  | "success"
  | "warn"
  | "error"
  | "copy"
  | "delete"
  | "send"
  | "undo"
  | "notify"
  | "info";

/** Events that the document-level delegation listener can fire from a `data-feedback` attribute. */
export const DELEGATED_EVENTS = ["tap", "select", "copy", "delete"] as const;

/**
 *
 */
export type DelegatedEvent = (typeof DELEGATED_EVENTS)[number];

/**
 *
 */
export function isDelegatedEvent(
  value: string | null
): value is DelegatedEvent {
  return (DELEGATED_EVENTS as readonly string[]).includes(value ?? "");
}
